import styled from '@xstyled/styled-components'
import { getButtonNumericSize } from './Common.styles'

const marginRight = getButtonNumericSize('s').width

export const StyledPlayerButtonRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  button: {
    marginRight: 32
  },
  marginRight
})
